import { render } from "./LostPassword.vue?vue&type=template&id=fe42d44c&scoped=true&ts=true"
import script from "./LostPassword.vue?vue&type=script&lang=ts"
export * from "./LostPassword.vue?vue&type=script&lang=ts"

import "./LostPassword.vue?vue&type=style&index=0&id=fe42d44c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe42d44c"]])

export default __exports__